import { useReactiveVar } from "@apollo/client";
import React, { useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { revokeAccessModalVar } from "../../../graphql/globalVar/state";
import { notificationService } from "../../../services/notificationService";

function RevokeAccessModal() {
  const { t } = useTranslation();
  const revokeAccess = useReactiveVar(revokeAccessModalVar);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => revokeAccessModalVar(null);

  const handleConfirm = async () => {
    if (revokeAccess === null) return;
    setIsLoading(true);
    try {
      await revokeAccess.onConfirm();
      revokeAccessModalVar(null);
    } catch {
      notificationService.danger({
        msg: t("events.somethingWentWrong"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      show={revokeAccess !== null}
      onHide={handleClose}
      centered
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3">
        <Modal.Title className="fs-4 fw-bold">
          {t("events.access.revokeTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="fs-6 text-center px-4 py-3">
        {t("events.access.revokeDescription")}
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0">
        <Row className="g-2 w-100 m-0">
          <Col md={{ span: 6 }}>
            <Button
              variant="outline-danger"
              className="w-100 py-3 fw-normal lh-sm rounded-3"
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {t("events.access.revokeConfirm")}
            </Button>
          </Col>
          <Col md={{ span: 6 }}>
            <Button
              variant="success"
              className="py-3 w-100 lh-sm fw-bold rounded-3"
              onClick={handleClose}
              disabled={isLoading}
            >
              {t("events.cancel")}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default RevokeAccessModal;
